import React from "react";
import { isArray } from "lodash";
import { _getBaseUrl, _getTranslation } from "../utils/helper";

const ContactLibrary = ({ data, ...props }) => {
  return (
    <div className="library-link">
      <div class="h-full w-full">
        <div class="flex gap-5 items-start pb-4">
          <img
            src={data.imageUrl}
            alt={data.imageAlt}
            class="w-[140px] h-[94px] object-cover rounded-full"
          />
          <div class="py-2 text-cirBlack w-8/12 flex flex-col justify-start items-start text-left">
            <h3 class="font-semibold text-lg">{data.title}</h3>
            <div class="font-normal text-base">{data.role}</div>
            <div class="pt-2 text-base">
              <a
                href={data.permalink}
                class="text-cirBlack nav-icon flex gap-2.5 hover:underline hover:underline-offset-4"
              >
                Stuur een bericht
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ContactLibrary;
